import { createQuery } from '@tanstack/svelte-query';
import { QUERY_KEY_TOP_SHORTLINKS } from '../constants';

const getTopShortlinks = async ({ startDate, endDate, socialPlatform }) => {
  if (!startDate || !endDate) return [];

  const response = await fetch(
    `/api/top-shortlinks?${new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      ...(socialPlatform && { social_platform: socialPlatform }),
    })}`,
  );
  const data = await response.json();

  return data.objects;
};

export const queryTopShortlinks = (
  { startDate, endDate, socialPlatform },
  queryOptions,
) =>
  createQuery({
    queryKey: [
      QUERY_KEY_TOP_SHORTLINKS,
      {
        startDate,
        endDate,
        socialPlatform,
      },
    ],
    queryFn: () =>
      getTopShortlinks({
        startDate,
        endDate,
        socialPlatform,
      }),
    refetchOnWindowFocus: false,
    retry: false,
    ...queryOptions,
  });
